// Normalise share URLs from Loom / YouTube / Vimeo / Wistia to their /embed/ form.
// Share URLs return X-Frame-Options:deny on iframes, so embedding requires this.
const WISTIA_ID = [
  /fast\.wistia\.(?:net|com)\/embed\/(?:iframe|medias)\/([a-z0-9]+)/i,
  /wistia\.com\/medias\/([a-z0-9]+)/i,
  /media-id=["']([a-z0-9]+)["']/i,           // <wistia-player media-id="…"> snippet
  /fast\.wistia\.com\/embed\/([a-z0-9]+)\.js/i, // <script src="…/embed/ID.js"> from the same snippet
  /wistia_async_([a-z0-9]+)/i,
  /[?&]wvideo=([a-z0-9]+)/i,
];

export function wistiaId(raw) {
  const s = String(raw || '');
  for (const rx of WISTIA_ID) { const m = s.match(rx); if (m) return m[1].toLowerCase(); }
  return '';
}

export function normalizeEmbedUrl(raw, { autoplay = false } = {}) {
  if (!raw) return '';
  const url = String(raw).trim();
  const ap = autoplay ? '1' : '0';
  const loom = url.match(/loom\.com\/(?:share|embed)\/([a-zA-Z0-9]+)/);
  if (loom) return `https://www.loom.com/embed/${loom[1]}${autoplay ? '?autoplay=1' : ''}`;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?rel=0&modestbranding=1&autoplay=${ap}`;
  const vm = url.match(/(?:^|\/\/)(?:www\.)?vimeo\.com\/(?!video\/)(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}?autoplay=${ap}`;
  const ws = wistiaId(url);
  if (ws) return `https://fast.wistia.net/embed/iframe/${ws}?seo=false&videoFoam=true&autoPlay=${autoplay ? 'true' : 'false'}`;
  // Wistia “/s/…” short links carry no media id — the server resolves them when the admin saves.
  return url.startsWith('<') ? '' : url;
}

// Automatic poster for YouTube links; other hosts need a custom thumbnail.
export function getVideoThumbnail(raw) {
  if (!raw) return '';
  const yt = String(raw).match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/);
  if (yt) return `https://i.ytimg.com/vi/${yt[1]}/hqdefault.jpg`;
  return '';
}
